module.exports = __webpack_public_path__ + "img/glasses.bd39b3bc.svg";